import React, { useEffect, useState } from "react";
import searcher from "../../../assets/searchInput.svg";
import FFdesignationVersionTable from "./FFdesignationVersionTable";
import back from "../../../assets/back.svg";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

const FieldForceDesignationVersionList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const search = queryParamsData.get("search") ?? "";

  const filterData = {
    approval_limit_from: queryParamsData.get("approval_limit_from") ?? "",
    approval_limit_to: queryParamsData.get("approval_limit_to") ?? "",
  };

  const queryParams = [];
  if (filterData?.approval_limit_from)
    queryParams.push(`approval_limit_from=${filterData?.approval_limit_from}`);
  if (filterData?.approval_limit_to)
    queryParams.push(`approval_limit_to=${filterData?.approval_limit_to}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/field-force/designation",
      breadcrumb: " / field force / designation",
    },
    {
      path: "/field-force/designation/version-history",
      breadcrumb: " / version history",
    },
  ];
  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });
  return (
    <div className="products-page">
      <div className="products-main-div">
        <div className="mx-3">
          {breadcrumbs.map(({ match, breadcrumb }) => (
            <NavLink
              key={match.pathname}
              to={match.pathname}
              className="header-route-page fw_400 cursor_pointer"
            >
              <span className="fs_18">{breadcrumb}</span>
            </NavLink>
          ))}
        </div>
        <div className="products-main-list my-2 py-1 d-flex justify-content-between flex-column">
          <div>
            <div className="search-container d-flex justify-content-between align-items-center">
              <div className="d-flex w-100">
                <div
                  className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                  onClick={() => navigate("/field-force/designation")}
                >
                  <img src={back} alt="back_btn" />
                  <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                    BACK
                  </span>
                </div>
                <div className="d-flex justify-content-between w-100">
                  <div className="search-box d-flex  align-items-center p-2 ms- m-1 mb-2">
                    <img className="styled-SVG" src={searcher} alt="o" />
                    <input
                      value={search}
                      className="search-input text-dark fw_400 px-2"
                      type="text"
                      placeholder="Search Designation ID, Designation Name, etc."
                      onChange={(e) => {
                        navigate(
                          `/field-force/designation/version-history?page=1${
                            e.target.value ? `&search=${e.target.value}` : ""
                          }${queryString}`
                        );
                      }}
                    />
                  </div>
                  <button
                    onClick={() =>
                      navigate(`/field-force/designation/version-history`)
                    }
                    className="m-2 border-0 rounded-2 mx-2 px-3 fs_14 Medium_Purple"
                  >
                    Clear Filters
                  </button>
                </div>
              </div>
            </div>
            <div></div>
            <FFdesignationVersionTable
              search={search}
              page_no={page_no}
              filterData={filterData}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FieldForceDesignationVersionList;
